/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    BookingItemsSuccessResponseResponse,
    EditBookingItemSuccessResponseResponse,
    GetBookingItemsParams,
    UpdateBookingItemCheckinNoteBodyBody,
    UpdateBookingItemCheckinNoteParams,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get booking items matching the filters
 */
export const getBookingItems = (params?: GetBookingItemsParams, signal?: AbortSignal) => {
    return customInstance<BookingItemsSuccessResponseResponse>({
        url: `/bookingitems`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetBookingItemsQueryKey = (params?: GetBookingItemsParams) => {
    return [`/bookingitems`, ...(params ? [params] : [])] as const;
};

export const getGetBookingItemsQueryOptions = <
    TData = Awaited<ReturnType<typeof getBookingItems>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetBookingItemsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingItems>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetBookingItemsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingItems>>> = ({ signal }) =>
        getBookingItems(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getBookingItems>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetBookingItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingItems>>>;
export type GetBookingItemsQueryError = APIErrorResponseResponse;

/**
 * @summary Get booking items matching the filters
 */

export function useGetBookingItems<
    TData = Awaited<ReturnType<typeof getBookingItems>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetBookingItemsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getBookingItems>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetBookingItemsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit booking item checkin note
 */
export const updateBookingItemCheckinNote = (
    id: number,
    updateBookingItemCheckinNoteBodyBody: UpdateBookingItemCheckinNoteBodyBody,
    params?: UpdateBookingItemCheckinNoteParams,
) => {
    return customInstance<EditBookingItemSuccessResponseResponse>({
        url: `/bookingitems/${id}/checkinnote`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateBookingItemCheckinNoteBodyBody,
        params,
    });
};

export const getUpdateBookingItemCheckinNoteMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateBookingItemCheckinNote>>,
        TError,
        {
            id: number;
            data: UpdateBookingItemCheckinNoteBodyBody;
            params?: UpdateBookingItemCheckinNoteParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateBookingItemCheckinNote>>,
    TError,
    {
        id: number;
        data: UpdateBookingItemCheckinNoteBodyBody;
        params?: UpdateBookingItemCheckinNoteParams;
    },
    TContext
> => {
    const mutationKey = ['updateBookingItemCheckinNote'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateBookingItemCheckinNote>>,
        {
            id: number;
            data: UpdateBookingItemCheckinNoteBodyBody;
            params?: UpdateBookingItemCheckinNoteParams;
        }
    > = (props) => {
        const { id, data, params } = props ?? {};

        return updateBookingItemCheckinNote(id, data, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateBookingItemCheckinNoteMutationResult = NonNullable<
    Awaited<ReturnType<typeof updateBookingItemCheckinNote>>
>;
export type UpdateBookingItemCheckinNoteMutationBody = UpdateBookingItemCheckinNoteBodyBody;
export type UpdateBookingItemCheckinNoteMutationError = APIErrorResponseResponse;

/**
 * @summary Edit booking item checkin note
 */
export const useUpdateBookingItemCheckinNote = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateBookingItemCheckinNote>>,
        TError,
        {
            id: number;
            data: UpdateBookingItemCheckinNoteBodyBody;
            params?: UpdateBookingItemCheckinNoteParams;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof updateBookingItemCheckinNote>>,
    TError,
    {
        id: number;
        data: UpdateBookingItemCheckinNoteBodyBody;
        params?: UpdateBookingItemCheckinNoteParams;
    },
    TContext
> => {
    const mutationOptions = getUpdateBookingItemCheckinNoteMutationOptions(options);

    return useMutation(mutationOptions);
};
